import React from 'react';

/**
 * Arc-reactor core, CSS only. `mode` drives the animation:
 * idle | thinking | speaking | listening | offline. Decorative (aria-hidden);
 * the surrounding UI carries the state in text. Motion is disabled under
 * prefers-reduced-motion in jarvis.css.
 */
export default function ArcReactor({ mode = 'idle', size = 'md' }) {
  return (
    <div className={`jv-reactor jv-reactor--${size} jv-reactor--${mode}`} aria-hidden="true">
      <div className="jv-reactor-ring jv-reactor-ring--outer" />
      <div className="jv-reactor-ring jv-reactor-ring--ticks" />
      <div className="jv-reactor-ring jv-reactor-ring--mid" />
      <div className="jv-reactor-segments">
        {Array.from({ length: 10 }, (_, i) => (
          <span key={i} style={{ transform: `rotate(${i * 36}deg)` }} />
        ))}
      </div>
      <div className="jv-reactor-core" />
    </div>
  );
}
